import { render } from "./HistoryBlock.vue?vue&type=template&id=6adcafb2&scoped=true"
import script from "./HistoryBlock.vue?vue&type=script&lang=js"
export * from "./HistoryBlock.vue?vue&type=script&lang=js"

import "./HistoryBlock.vue?vue&type=style&index=0&id=6adcafb2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6adcafb2"]])

export default __exports__